import KeyValueSublabelDropdown from "components/dropdowns/reactselect/KeyValueSublabelDropdown";
import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";

interface Props {
  invoiceWordTemplates: server.dto.KeyValueSublabel[];
  invoiceEmailTemplates: server.dto.KeyValueSublabel[];
  selectedInvoiceWordTemplateId: number;
  selectedInvoiceEmailTemplateId: number;
  clientId: number
}

export const invoicingSection = (props: Props): FormSection => {
  const { invoiceWordTemplates, invoiceEmailTemplates, selectedInvoiceEmailTemplateId, selectedInvoiceWordTemplateId, clientId } = props;
  const initialWordTemplate = invoiceWordTemplates.find(template => template.key === selectedInvoiceWordTemplateId);
  const initialEmailTemplate = invoiceEmailTemplates.find(template => template.key === selectedInvoiceEmailTemplateId);

  return {
    key: "invoicingDetails",
    type: "regular",
    title: "Invoicing",
    fields: [
      {
        key: "wordTemplate",
        label: "PDF Template",
        render: () => <div>{initialWordTemplate.value}</div>,
        inPageEdit: {
          render: ({ value, onChange }) => <KeyValueSublabelDropdown
            value={value}
            onChange={onChange}
            options={invoiceWordTemplates}
          />,
          fullWidth: true,
          type: "confirmOrCancelButtonInline",
          initialValue: initialWordTemplate,
          submitChange: async (i) => window.CoreApi.Client.UpdateInvoicingTemplateSetting({ clientId, invoiceEmailTemplateId: selectedInvoiceEmailTemplateId, invoiceWordTemplateId: i.key })
        }
      }, {
        key: "emailTemplate",
        label: "Email Template",
        render: () => <div>{initialEmailTemplate.value}</div>,
        inPageEdit: {
          render: ({ value, onChange }) => <KeyValueSublabelDropdown
            value={value}
            onChange={onChange}
            options={invoiceEmailTemplates}
          />,
          fullWidth: true,
          type: "confirmOrCancelButtonInline",
          initialValue: initialEmailTemplate,
          submitChange: async (i) => window.CoreApi.Client.UpdateInvoicingTemplateSetting({ clientId, invoiceEmailTemplateId: i.key, invoiceWordTemplateId: selectedInvoiceWordTemplateId })
        }
      }
    ]
  }
}

